module.exports = __webpack_public_path__ + "static/media/06-cht.f181e393.png";